import { useSelector } from "react-redux";

import { FreshpaintState } from "../reducers";

export default function useLoginPage() {
  return useSelector((state: FreshpaintState) => state.loginPage.loginPage);
}
